import styled from 'styled-components';
import ExpiredLinkIcon from '@/images/ExpiredLinkIcon.svg?react';

export const Icon = styled(ExpiredLinkIcon)`
  margin-bottom: 28px;
`;
